export const LOCAL_STORAGE_KEY = "@@react-dark-theme-context/THEME";
